
import { PropType, computed, defineComponent } from 'vue';

import SBtn from 'SharedComponents/ui/Button/SBtn.vue';
import { useValue } from 'SharedDir/common/composables/useValue';
import { RU_MASK } from 'SharedDir/constants/datepicker';
import { dateDisplayToInternal, dateInternalToDisplay, dateRule } from 'SharedDir/utils/date-rule';

import SInput from './SInput.vue';

export default defineComponent({
  name: 'SInputDate',
  components: {
    SBtn,
    SInput,
  },
  props: {
    modelValue: {
      required: false,
      type: String as PropType<string | null>,
      default: null,
    },
    propsDate: {
      required: false,
      type: Object,
    },
    required: {
      required: false,
      default: false,
      type: Boolean,
    },
    readonly: {
      required: false,
      default: false,
      type: Boolean,
    },
    additionalInputRules: {
      required: false,
      default: () => [],
      type: Array,
    },
    debounce: Number,
    rules: Array as PropType<((value?) => true | string)[]>,
    lazyRules: {
      default: 'ondemand',
      type: [String, Boolean] as PropType<boolean | 'ondemand'>,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { slots, emit }) {
    const { innerValue, emitValue } = useValue(props, emit, {
      transform: (v) => dateInternalToDisplay(v),
      mrofsnart: (iv) => dateDisplayToInternal(iv),
      debounce: props.debounce,
    });

    const resultRules = computed(() => [dateRule, ...(props.rules || [])]);

    const filteredSlots = Object.fromEntries(
      Object.entries(slots).filter(([name]) => name !== 'append')
    );
    return {
      filteredSlots,
      RU_MASK,
      dateRule,
      innerValue,
      emitValue,
      resultRules,
    };
  },
});
